import { EmployeeJobInterestDto } from './EmployeeJobInterestDto';
import { PlantDto } from './PlantDto';

export interface JobOpeningsResult {
  OpeningsCount: number;
  ClassName: string;
  StartDate: Date;
  EndDate: Date;
  JobID: string;
  JobName: string;
  Name: string;
  VPJobId: string;
  OpeningId: string;
  Plant: PlantDto;
  TotalCount: number;
  TradeClassName: string;
  JobClass?: string;
  TradeClassID: string;
  Interest: EmployeeJobInterestDto;
  vManPowerOpeningId: string;
  Shift: number;
  SupervisorName?: string;
}
